import type { Content, Link as LinkType } from 'mdast'
import * as React from 'react'

import { Link } from '../../link/Link'

type MarkdownLinkProps = {
  node: LinkType
  handleNode: (node: Content) => React.ReactElement<unknown>
}

export const MarkdownLink = ({ node, handleNode }: MarkdownLinkProps) => (
  <Link title={node.title ?? undefined} href={node.url}>
    {node.children?.map(handleNode)}
  </Link>
)
